import React, { useLayoutEffect, useRef, useEffect, useState, useCallback } from 'react';
import Keyboard from '@components/KeyboardV2';
import Loader from '@components/common/Loader/newLoaderModal';
import cn from 'classnames';
import style from './giftCardEntry.module.css';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { APP_CONFIG } from '@constants';
import { flowType } from '@utility/userInfo';
import { urlSearchParams } from '../../utility/utills';
import EventEmitter from '@utility/eventSubscribers';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import {
  TouchableButton,
  TouchableDiv,
} from '@components/common/Touchable';
import ModalHeader from '@components/common/ModalHeader/index';

const GiftCardEntry = props => {
  // Props Destructuring

  const {
    handleGiftCardProcess,
    openCardPopUp,
    loading,
    balancePopUp,
    handleClosePopup,
    serverAppTheme,
    setInputs,
    inputs,
    setSwipedDown,
    setTyped,
    typed,
    setErrorPopUp,
    isSecurityCode,
    checkbalance = false,
    isSwipe,
    menuItemsHashTable,
    selectedMenuItemId,
    setDisplayImage,
    swipeGiftCard,
    orderData,
    menuItemName,
    balanceEnabled,
    setGameCardFlowType,
    isBalanceRoute,
    orderingPortraitOrientation
  } = props;

  // State Management
  const isSecurityCodeRequired = props.auth?.loyaltyInfo?.validateGiftCardSecurityCode || isSecurityCode;
  const [activeElement, setActiveElement] = useState('cardNumber');

  const ref = useRef(null);
  const keyboard = useRef(null);
  const [error, setError] = useState('');
  const typedRef = useRef(typed);
  const inputsRef = useRef(inputs);
  typedRef.current = typed;
  inputsRef.current = inputs;
  // Stable ref — read at call time so useCallback deps stay empty
  const activeElementRef = useRef(activeElement);
  activeElementRef.current = activeElement;
  let disPlayCancelIcon = urlSearchParams('type') == 'payment' ? true : false;

  // React Hooks

  useLayoutEffect(() => {
    if (window.ReactNativeWebView) {
      if (disPlayCancelIcon) {
        EventEmitter.changeOrientation({
          orientation: 'portrait',
        });
      }
    }
  }, []);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  useEffect(() => {
    if (!isSwipe) {
      if (setInputs) setInputs({});
      if (setTyped) setTyped({});
    }
  }, [isSwipe]);

  // Methods

  const getGiftCardImage = () => {
    const menuItemId = selectedMenuItemId;
    const intermediateImageUrl = menuItemsHashTable[menuItemId]?.intermediateImageUrl;
    return intermediateImageUrl || swipeGiftCard;
  };

  const handleClickOutside = e => {
    if (ref.current && !ref.current.contains(e.target)) {
      setSwipedDown(false);
    }
  };


  const getInput = key => {
    return inputs[key] ? inputs[key] : '';
  };

  const handleBlur = () => {
    if (document.querySelector('#cardNumber')) {
      document.querySelector('#cardNumber').blur();
    }
    if (document.querySelector('#securityCode')) {
      document.querySelector('#securityCode').blur();
    }
  };

  const handleChangeInput = data => {
    setSwipedDown(true);
    if (keyboard.current) {
      keyboard.current.setInput(inputs[data], data);
    }
  };

  const closeKeyboard = useCallback(() => {
    setSwipedDown(false);
  }, []);

  // Stable reference — reads activeElement/typed/inputs via refs so
  // useCallback has empty deps and never invalidates KeyboardV2 memo boundaries.
  const onClickBtn = useCallback(e => {
    const currentActive = activeElementRef.current;
    const currentTyped = typedRef.current;
    const currentInputs = inputsRef.current;
    setError('');
    setTyped(
      e === '{bksp}'
        ? { ...currentTyped, [currentActive]: currentTyped[currentActive]?.slice(0, -1) }
        : {
          ...currentTyped,
          [currentActive]: currentTyped[currentActive]
            ? currentTyped[currentActive].concat(e)
            : ''.concat(e),
        }
    );
    const value =
      e === '{bksp}'
        ? { ...currentTyped, [currentActive]: currentTyped[currentActive]?.slice(0, -1) }
        : {
          ...currentTyped,
          [currentActive]: currentTyped[currentActive]
            ? currentTyped[currentActive].concat(e)
            : ''.concat(e),
        };
    setInputs({
      ...currentInputs,
      [currentActive]: value[currentActive],
    });
  }, []);

  const handleSetInputEmpty = useCallback(() => {
    setInputs({ ...inputsRef.current, [activeElementRef.current]: '' });
    setTyped({ ...typedRef.current, [activeElementRef.current]: '' });
  }, []);

  const setEmpty = data => {
    setInputs({
      ...inputsRef.current,
      [data]: '',
    });
    setTyped({
      ...typedRef.current,
      [data]: '',
    });
  };
 

const handleClose = useCallback(() => {
  if (disPlayCancelIcon) {
    return props.navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${props.seat.id
      }?ticketSplitTypeId=1&splitValue=1&screenType=27&type=${urlSearchParams(
        'type'
      )}`,
      { replace: true }
    );
  }

  if (isBalanceRoute) {
    return props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, {
      replace: true,
    });
  }

  if (props.setInputs) props.setInputs({});
  if (props.setTyped) props.setTyped({});
  setGameCardFlowType(1);
}, [disPlayCancelIcon, isBalanceRoute]);

  const handleApplyGiftCard = () => {
    if (!inputs?.cardNumber || inputs?.cardNumber.length === 0) {
      setErrorPopUp({
        res: CUSTOM_MESSAGES().OS_GIFT_CARD_NUMBER,
        noErrorTxt: true,
      });
      return;
    }

    if (isSecurityCodeRequired && (!inputs?.securityCode || inputs?.securityCode.length === 0)) {
      setErrorPopUp({
        res: CUSTOM_MESSAGES().PLEASE_ENTRE_THE_SECURITY_CODE,
        noErrorTxt: true,
      });
      return;
    }

    if (isSecurityCodeRequired) {
      handleGiftCardProcess({
        cardNumber: inputs?.cardNumber,
        securityCode: inputs?.securityCode,
        method: 'type'
      });
    } else {
      handleGiftCardProcess(inputs?.cardNumber);
    }
    setInputs("");
    setTyped("");
  }
  // HTML CSS Code

  return (
    <div
      ref={ref}
      className={cn(
        'col-12 col-md-12 p-0 mx-0 h-100 rowReverse position-realtive'
      )}
      style={{
        backgroundColor: serverAppTheme.popUp_bg,
        border: serverAppTheme?.popupBorder,
        // boxShadow: serverAppTheme?.popUp_box_shadow,
        color: serverAppTheme?.primary_text,
      }}
    >
      {loading && <Loader />}
      <ModalHeader
        // isTab={props.seat?.tab}
        {...(urlSearchParams('type') == 'balance' ? {} : { isTab: props.seat?.tab })}
        {...(urlSearchParams('type') == 'balance' ? {} : { stationName: props.seat?.stationName })}
        // stationName={props.seat?.stationName}
        tileHeader="Gift Card"
        // seatNumber={props.seat?.number}
        {...(urlSearchParams('type') == 'balance' ? {} : { seatNumber: props.seat?.number })}
      />
      {!(isSwipe || balancePopUp.state) &&
        <>
          <div className={cn('col-12 d-flex flex-column align-items-center', orderData ? 'py-0' : 'py-4', orderingPortraitOrientation ? 'px-3' : 'px-0')} style={{ top: orderingPortraitOrientation ? '5%' : ''}}>
            {urlSearchParams("type") !== "balance" && orderData && (
              <div
                className={cn("col-5  d-flex justify-content-between px-2 py-0",orderingPortraitOrientation ?'my-3 fs_18' :'my-2 fs_20')}
                style={{
                  backgroundColor: serverAppTheme?.popUp_bg,
                  borderRadius: "8px",
                  color: serverAppTheme?.primary_text,
                  fontWeight: 600,
                }}
              >
                <span>{menuItemName}</span>
                {orderData?.amount !== 0 && (
                  <span>{LABEL().CURRENCY_SYMBOL}{orderData?.amount?.toFixed(2)}</span>
                )}
              </div>
            )}
            {(balanceEnabled ? props.auth?.loyaltyInfo?.giftCardMethods?.includes('swipe') : props.auth?.loyaltyInfo?.giftCardSaleMethods?.includes('swipe')) && (
              <div className={cn(orderData ? 'mb-0' : 'mb-2', orderingPortraitOrientation ? 'col-12 px-0' : 'col-10 px-1')}>
                <TouchableButton
                  type="submit"
                  className={cn(
                    'col-12 btn-ripple border-0 rounded text-white fs_24 fw-600',
                    orderingPortraitOrientation ? 'btn68' : 'btn44'
                  )}
                  style={{
                    // height: '8.6vh',
                    backgroundColor: serverAppTheme?.secondaryBtn,
                    color: serverAppTheme?.btn_font_color,
                  }}
                  onClick={e => {
                    e.preventDefault();
                    setDisplayImage(getGiftCardImage());
                    openCardPopUp();
                  }}
                  rippleEffect={true}
                >
                  {LABEL().HAMBERGER_GIFTCARD_SWIPE}
                </TouchableButton>
              </div>
            )}
            {(true &&
              (balanceEnabled ? (props.auth?.loyaltyInfo?.giftCardMethods?.includes('swipe') &&
                props.auth?.loyaltyInfo?.giftCardMethods?.includes('type')) : (props.auth?.loyaltyInfo?.giftCardSaleMethods?.includes('swipe') &&
                  props.auth?.loyaltyInfo?.giftCardSaleMethods?.includes('type')))) && (
                <div className={cn("col-10 px-0 d-flex align-items-center justify-content-center fw-600", orderingPortraitOrientation ? 'mt-3' : 'my-1')}>
                  OR
                </div>
              )}
            {(true &&
              (balanceEnabled ? (props.auth?.loyaltyInfo?.giftCardMethods === null ||
                props.auth?.loyaltyInfo?.giftCardMethods?.length === 0 ||
                props.auth?.loyaltyInfo?.giftCardMethods?.includes('type') ||
                props.auth?.loyaltyInfo?.giftCardMethods?.includes('')) :
                (props.auth?.loyaltyInfo?.giftCardSaleMethods === null ||
                  props.auth?.loyaltyInfo?.giftCardSaleMethods?.length === 0 ||
                  props.auth?.loyaltyInfo?.giftCardSaleMethods?.includes('type') ||
                  props.auth?.loyaltyInfo?.giftCardSaleMethods?.includes('')))) && (
                <div
                  className={cn(
                    'col-12',
                    'px-0 d-flex flex-column align-items-center', orderData ? 'mt-0' : 'mt-2'
                  )}
                >
                  <div className={cn('col-12 px-0', isSecurityCodeRequired ? 'justify-content-between' : 'justify-content-center', orderingPortraitOrientation ? '' : 'd-flex')}>
                    <div className={cn('position-relative', isSecurityCodeRequired ? (orderingPortraitOrientation ? 'col-12 py-3 px-0' : 'col-6 pr-1') : 'col-12')}>
                      <input
                        value={getInput('cardNumber')}
                        className={cn(
                          'form-control rounded-0 fs_24 pl-3',
                          style.input
                        )}
                        type="text"
                        style={{
                          height: orderingPortraitOrientation ? '4rem' : '8.6vh',
                          backgroundColor: serverAppTheme?.inputBg,
                          border: 'none',
                          borderBottom: serverAppTheme?.inputBorder_Bottom,
                          color: serverAppTheme?.primary_text,
                          '--placeholder-color': serverAppTheme?.input_placeholder,
                          paddingRight: '3rem',
                        }}
                        id="cardNumber"
                        name="cardNumber"
                        onFocus={() => {
                          handleChangeInput('cardNumber');
                          setActiveElement('cardNumber');
                          handleBlur();
                        }}
                        placeholder={CUSTOM_MESSAGES().ENTER_CARD_NUMBER}
                      />
                      {inputs?.cardNumber?.length > 0 && (
                        <TouchableDiv
                          role="presentation"
                          className="position-absolute"
                          style={{
                            top: '49%',
                            right: '1rem',
                            transform: 'translateY(-50%)',
                          }}
                          onClick={() => {
                            setEmpty('cardNumber');
                            setActiveElement('cardNumber');
                          }}
                        >
                          <Cross fill={serverAppTheme?.iconcolor} alt="X" />
                        </TouchableDiv>
                      )}
                    </div>
                    {isSecurityCodeRequired && (
                      <div className={cn("position-relative", orderingPortraitOrientation ? 'col-12 px-0' : 'col-6 pl-1 ')}>
                        <input
                          value={getInput('securityCode')}
                          className={cn(
                            'form-control rounded-0 fs_24 pl-3',
                            style.input
                          )}
                          type="text"
                          style={{
                            height: orderingPortraitOrientation ? '4rem' : '8.6vh',
                            backgroundColor: serverAppTheme?.inputBg,
                            border: 'none',
                            borderBottom: serverAppTheme?.inputBorder_Bottom,
                            color: serverAppTheme?.primary_text,
                            '--placeholder-color': serverAppTheme?.input_placeholder,
                            paddingRight: '3rem',
                          }}
                          id="securityCode"
                          name="securityCode"
                          onFocus={() => {
                            handleChangeInput('securityCode');
                            setActiveElement('securityCode');
                            handleBlur();
                          }}
                          placeholder={LABEL().GS_CLICK_TO_ENTER_SECURITY_CODE}
                        />
                        {inputs?.securityCode?.length > 0 && (
                          <TouchableDiv
                            role="presentation"
                            className="position-absolute"
                            style={{
                              top: '49%',
                              right: '1.4rem',
                              transform: 'translateY(-50%)',
                            }}
                            onClick={() => {
                              setEmpty('securityCode');
                              setActiveElement('securityCode');
                            }}
                          >
                            <Cross fill={serverAppTheme?.iconcolor} alt="X" />
                          </TouchableDiv>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
            {(balanceEnabled ? !(props.auth?.loyaltyInfo?.giftCardMethods?.length === 1 &&
              props.auth?.loyaltyInfo?.giftCardMethods?.includes('swipe')) : !(props.auth?.loyaltyInfo?.giftCardSaleMethods?.length === 1 &&
                props.auth?.loyaltyInfo?.giftCardSaleMethods?.includes('swipe'))) && (
                // swipedDown
                <div
                  className={cn('p-2 w-100', orderingPortraitOrientation ? 'mt-3': 'position-fixed')}
                  style={{
                    bottom: orderingPortraitOrientation ? '25%' : '15%',
                    left: 0,
                    backgroundColor: serverAppTheme?.keyBoard_Bg_Color,
                  }}
                >
                  <Keyboard
                    onClickBtn={onClickBtn}
                    type="number"
                    closeKeyboard={closeKeyboard}
                    btnSize="btn15"
                    customClass="fs-30"
                    maxLength={30}
                    tableKeyHeight
                    setinputEmpty={handleSetInputEmpty}
                  />
                </div>
              )}
          </div>
          {(balanceEnabled ? (props.auth?.loyaltyInfo?.giftCardMethods === null ||
            props.auth?.loyaltyInfo?.giftCardMethods?.length === 0 ||
            props.auth?.loyaltyInfo?.giftCardMethods?.includes('type') ||
            props.auth?.loyaltyInfo?.giftCardMethods?.includes('')) :
            (props.auth?.loyaltyInfo?.giftCardSaleMethods === null ||
              props.auth?.loyaltyInfo?.giftCardSaleMethods?.length === 0 ||
              props.auth?.loyaltyInfo?.giftCardSaleMethods?.includes('type') ||
              props.auth?.loyaltyInfo?.giftCardSaleMethods?.includes(''))) && (
              <div
                className={cn("d-flex align-items-center mt-3 col-12 justify-content-center position-absolute", orderingPortraitOrientation ? 'px-3' : 'px-0')}
                style={{ bottom: '3%' }}
              >
                <TouchableButton
                  className={cn(
                    'mr-1 btn-ripple d-flex justify-content-center align-items-center rounded fs_24 fw-600',
                    orderingPortraitOrientation ? 'btn68' : 'col-5 btn44'
                  )}
                  style={{
                    // height: '8.6vh',
                    width : orderingPortraitOrientation ? '50%' : '',
                    backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                    border: serverAppTheme?.cancleBtn_Border,
                    color: serverAppTheme?.cancleBtn_font,
                    borderRadius: '8px',
                  }}
                  onClick={e => {
                    e.preventDefault();
                    if (balanceEnabled) window.sessionStorage.removeItem('giftCard_type');
                    handleClose();
                  }}
                  rippleEffect={true}
                >
                  {LABEL().CANCEL}
                </TouchableButton>
                <TouchableButton
                  type="submit"
                  className={cn(
                    'ml-1 border-0 btn-ripple d-flex justify-content-center align-items-center rounded fs_24 fw-600',
                    orderingPortraitOrientation ? 'btn68' : 'col-5 btn44'
                  )}
                  style={{
                    // height: '8.6vh',
                    backgroundColor:
                      serverAppTheme?.secondaryBtn,
                    color:
                      serverAppTheme?.btn_font_color,
                      width : orderingPortraitOrientation ? '48%' : '',
                  }}
                  // disabled={inputs?.cardNumber?.length === 0 || inputs == ''}
                  onClick={e => {
                    e.preventDefault();
                    handleApplyGiftCard();
                  }}
                  rippleEffect={true}
                >
                  {checkbalance ? LABEL().HAMBURGER_GIFTCARD_BALANCE : LABEL().APPLY}
                </TouchableButton>
              </div>
            )}
          {(balanceEnabled ? (props.auth?.loyaltyInfo?.giftCardMethods?.length === 1 &&
            props.auth?.loyaltyInfo?.giftCardMethods?.includes('swipe')) : (
            props.auth?.loyaltyInfo?.giftCardSaleMethods?.length === 1 &&
            props.auth?.loyaltyInfo?.giftCardSaleMethods?.includes('swipe'))
          ) && (
              <div
                className="d-flex align-items-center mt-3 col-12 px-0 justify-content-center position-absolute"
                style={{ bottom: '3%' }}
              >
                <TouchableButton
                  className={cn(
                    'col-5 btn-ripple d-flex justify-content-center align-items-center rounded fs_24 fw-600'
                  )}
                  style={{
                    height: '8.6vh',
                    backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                    border: serverAppTheme?.cancleBtn_Border,
                    color: serverAppTheme?.cancleBtn_font,
                    borderRadius: '8px',
                  }}
                  onClick={e => {
                    e.preventDefault();
                    if (balanceEnabled) window.sessionStorage.removeItem('giftCard_type');
                    handleClose();
                  }}
                  rippleEffect={true}
                >
                  {LABEL().CANCEL}
                </TouchableButton>
              </div>
            )}
        </>
      }
      {/* <FullWidthModal
        isOpen={balancePopUp.state}
        noBackground
        customClass2={cn(style.QrModalWidth, 'p-3 h-100')}
        style={{
          backgroundColor: serverAppTheme.popUp_bg,
          borderRadius: '16px',
          border: serverAppTheme?.popupBorder,
          boxShadow: serverAppTheme?.popUp_box_shadow,
          height: '100%',
          width: '100%',
        }}
      > */}
      {balancePopUp.state &&
        <div className='h-94'>
          <div
            className="col-12 p-3 justify-content-center align-items-center position-relative text-center h-100"
            style={{ color: serverAppTheme?.primary_text }}
          >
            {/* <div
            style={{ top: '0.8rem', right: '0.8rem', zIndex: '999' }}
            className="position-absolute"
          >
            <TouchableCross
              fill={serverAppTheme?.iconcolor}
              role="presentation"
              onClick={() => handleClosePopup()}
              aria-hidden="true"
            />
          </div> */}
            <div
              className={cn("col-12 mb-10 justify-content-center align-items-center text-center", orderingPortraitOrientation ? 'mt-3' : '')}
              style={{ fontSize: orderingPortraitOrientation ? '24px' : '3vw' }}
            >
              {LABEL().CARDNUMBER + ': ' + (balancePopUp?.data?.displayCardNumber || balancePopUp?.cardNumber)}
            </div>
            <div
              className="col-12 mb-10 justify-content-center align-items-center text-center"
              style={{ fontSize: orderingPortraitOrientation ? '24px' : '3vw' }}
            >
              {LABEL().CARD_BALANCE + ': ' +
                `$${(balancePopUp?.data?.balanceAmount !== undefined
                  ? Number(balancePopUp?.data?.balanceAmount).toFixed(2)
                  : ''
                )}`
              }
            </div>
            <div
              style={{ bottom: 0 }}
              className={cn("col-12 px-0 py-1 justify-content-center align-items-center text-center position-absolute", orderingPortraitOrientation ? 'pb-1' : 'pb-3')}
            >
              <button
                className={cn("px-0 btn-ripple fs_24 fw-600 border-0  rounded", orderingPortraitOrientation ? 'col-6' : 'col-4')}
                type="button"
                onClick={() => {
                  if (balanceEnabled) window.sessionStorage.removeItem('giftCard_type');
                  handleClosePopup();
                }}
                style={{
                  height: '8.6vh',
                  backgroundColor: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
              >
                {LABEL().OK}
              </button>
            </div>
          </div>
        </div>}
      {/* </FullWidthModal> */}
    </div>
  );
};

export default GiftCardEntry;
